import { SplitFactory } from '@splitsoftware/splitio';
import { useTreatmentsWithConfig } from '@splitsoftware/splitio-react';

import { SPLIT_AUTHORIZATION_KEY, SPLIT_KEY } from '@/lib/config';

export const useSplitIO = (key: string, customAttributes: Record<string, string> = {}) => {
  // Custom Attributes
  const attributes = {
    system_time: new Date().getTime(),
    ...customAttributes,
  };

  const { treatments, isReady, isReadyFromCache } = useTreatmentsWithConfig({
    names: [key],
    attributes,
  });
  let t = treatments[key];
  let enabled = t.treatment === 'on';
  return [enabled, t.config, isReady || isReadyFromCache] as const;
};

const factory = SplitFactory({
  core: {
    authorizationKey: SPLIT_AUTHORIZATION_KEY,
    key: SPLIT_KEY,
  },
});

const client = factory.client();

export const getTreatment = async (treatment: string) => {
  if (process.env.NODE_ENV === 'test') {
    return {
      enabled: false,
      config: {},
    };
  }
  await client.ready();
  let r = client.getTreatmentWithConfig(treatment);
  let t = {
    enabled: r.treatment === 'on',
    config: JSON.parse(r.config ?? '{}'),
  };

  return t;
};
